import React from "react";
import "./PrivacyPolicy.css";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import SocialMediaPanel from "../common/social-media/SocialMediaPanel";

export default function PrivacyPolicy() {
  return (
    <>
      
       
      <main className="privacy-policy-page">
        {/* Header */}
        <header className="privacy-policy-header">
          <h1 className="privacy-policy-title">Privacy Policy – PYQPEDIA</h1>
          <span><strong>Effective Date:</strong> 25th September 2025.</span>
          <p className="privacy-policy-subtitle">
            At <strong>PYQPEDIA</strong>, we respect your privacy and are committed to protecting your personal information.
          </p>
        </header>

        {/* Content */}
        <section className="privacy-policy-content">
          {/* 1. Information We Collect */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">1. Information We Collect</h2>
            <ul className="privacy-policy-list">
              <li>Personal details (name, email, phone number, etc.) during registration/payment.</li>
              <li>Payment details via secure payment gateways (we do <strong>not</strong> store card/UPI details).</li>
              <li>Usage data for service improvements.</li>
            </ul>
          </article>

          {/* 2. How We Use Information */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">2. How We Use Information</h2>
            <ul className="privacy-policy-list">
              <li>To provide mock tests and educational services.</li>
              <li>To process transactions securely.</li>
              <li>To send updates, offers, and support messages (users can opt out).</li>
            </ul>
          </article>

          {/* 3. Data Security */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">3. Data Security</h2>
            <ul className="privacy-policy-list">
              <li>We use SSL encryption and trusted payment gateways for secure transactions.</li>
              <li>We do not sell, rent, or share your personal data with third parties, except as required by law.</li>
            </ul>
          </article>

          {/* 4. Cookies */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">4. Cookies</h2>
            <ul className="privacy-policy-list">
              <li>Our website may use cookies to enhance user experience. You can disable them in browser settings.</li>
            </ul>
          </article>

          {/* 5. Third-Party Links */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">5. Third-Party Links</h2>
            <ul className="privacy-policy-list">
              <li>Our site may contain links to third-party websites. We are not responsible for their policies or practices.</li>
            </ul>
          </article>

          {/* 6. Contact for Privacy Concerns */}
          <article className="privacy-policy-item">
            <h2 className="privacy-policy-item-title">6. Contact for Privacy Concerns</h2>
            <p>
              <strong>Email: </strong>
              <a
                href="mailto:support@pyqpedia.com"
                className="pyq-link no-capitalize"
              >
                support@pyqpedia.com
              </a>
            </p>
            <p>
              <strong>This website is operated by : </strong>
              B Jha
            </p>
            <p>
              <strong>Trade Name : </strong>
              Pyq Pedia
            </p>
          </article>
        </section>

        {/* Footer */}
        <footer className="privacy-policy-footer">
          <p>Issued by <strong>PYQPEDIA Team</strong></p>
        </footer>
      </main>

      
    </>
  );
}
